import { componentOutletConfigFactory } from '@recruitee/common';
import { injectTranslate } from '@recruitee/i18n';
import { EMPTY_CELL, TextCellComponent } from '@recruitee/user-interface';

import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';
import { defineOfferTableColumn } from './utils';

// eslint-disable-next-line max-lines-per-function
export const workModelColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.WorkModel,
  label: injectTranslate()('app.offers.table.work_model'),
  visible: true,
  geometry: {
    width: 130,
    minWidth: 130,
    maxWidth: 130,
  },
  options: {
    draggable: false,
    resizable: false,
    removable: true,
    sortable: false,
  },
  componentFactory: ({ row }) => {
    const { remote, onSite, hybrid } = row;
    if (remote || onSite || hybrid) {
      const t = injectTranslate();
      const workModelLabel = [
        ...(remote ? [t('app.offer_form.work_model_section.remote.title')] : []),
        ...(onSite ? [t('app.offer_form.work_model_section.on_site.title')] : []),
        ...(hybrid ? [t('app.offer_form.work_model_section.hybrid.title')] : []),
      ].join(', ');

      return componentOutletConfigFactory(TextCellComponent, {
        inputs: {
          class: 'work_model',
          value: workModelLabel,
        },
      });
    } else {
      return EMPTY_CELL;
    }
  },
}));
